import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { BulkUpdateTagsOperation, useBulkUpdateTags } from '@/api/jobs'
import BulkUpdateWrapper from '@/components/common/BulkUpdateWrapper.vue'
import TagsEditor from '@/components/common/tags/TagsEditor.vue'
import { SnackType } from '@/components/vision/SnackBarType'
import VsText from '@/components/vision/VsText.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import NewTag from '@/models/new_tag'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdateTagForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}

const tagUpdateOption = ref<'add' | 'remove' | 'overwrite'>('add')

const isSnackbarVisible = ref(false)
const snackbarMessage = ref()
const snackbarType = ref(SnackType.ERROR)
const tagsEditor = ref()

const hubId = computed(() => props.selectedJobs[0].hub_id)



const { mutateAsync: bulkUpdateTags, isLoading: isBulkUpdatingTags } =
  useBulkUpdateTags()

const operationMapping = {
  add: BulkUpdateTagsOperation.ADD,
  remove: BulkUpdateTagsOperation.REMOVE,
  overwrite: BulkUpdateTagsOperation.OVERWRITE,
}
const save = async () => {
  try {
    await bulkUpdateTags({
      jobIds: props.selectedJobs.map((j) => j.id),
      tags:
        tagsEditor.value?.currentTags
          .filter((tag: NewTag) => tag.isEditable)
          .map((tag: NewTag) => NewTag.toObject(tag).toDisplayString) ?? [],
      operation: operationMapping[tagUpdateOption.value],
    })
    emits('updated', {
      message: 'Tag updated',
      updatedJobs: props.selectedJobs,
    })
  } catch (err) {
    isSnackbarVisible.value = true
    snackbarMessage.value = err
  }
}

const introText = computed(() => {
  if (tagUpdateOption.value === 'add') {
    return 'Add tags...'
  } else if (tagUpdateOption.value === 'remove') {
    return 'Remove existing tags...'
  } else if (tagUpdateOption.value === 'overwrite') {
    return 'Change the tags to...'
  } else {
    return 'Unknown options'
  }
})
const dismiss = () => emits('dismiss')
const clearSnackbar = () => (isSnackbarVisible.value = false)

const handleError = (err: never) => {
  isSnackbarVisible.value = true
  snackbarMessage.value = err
}

return { __sfc: true,tagUpdateOption, props, isSnackbarVisible, snackbarMessage, snackbarType, tagsEditor, hubId, emits, bulkUpdateTags, isBulkUpdatingTags, operationMapping, save, introText, dismiss, clearSnackbar, handleError, BulkUpdateWrapper, TagsEditor, VsText, VsSnackbar, VsWrapper }
}

})